import React from "react";
import PropTypes from "prop-types";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import Link from "shared/components/Link";

import { URLS } from "apps/signup/util/constants";
import { SCREENS, SCREEN_SPEED } from "apps/login_old/util/constants";

import Logo from "../Logo";

import "./index.scss";

if (process.env.PLATFORM === "desktop") {
	require("./index.desktop.scss");
} else {
	require("./index.mobile.scss");
}

const Header = ({ screen, changeScreen, title }) => {
	const backClasses = "login2017-header-previous";
	const backContent = <i className="login2017-header-previous-icon" />;

	const onBack = () => {
		changeScreen(SCREENS.LOGIN);
	};

	return (
		<div className="login2017-header">
			{screen === SCREENS.LOGIN &&
				<Link
					className={backClasses}
					to={URLS.SPLASH}
				>
					{backContent}
				</Link>
			}
			{screen !== SCREENS.LOGIN &&
				<span
					className={backClasses}
					onClick={onBack}
					role="button"
					tabIndex="-1"
				>
					{backContent}
				</span>
			}

			<CSSTransitionGroup
				transitionName="login2017-header-title-transition"
				transitionEnterTimeout={SCREEN_SPEED}
				transitionLeaveTimeout={SCREEN_SPEED}
			>
				{title &&
					<span key={title} className="login2017-header-title">
						{title}
					</span>
				}
				{!title &&
					<Link key="logo" to={URLS.SPLASH}>
						<Logo />
					</Link>
				}
			</CSSTransitionGroup>
		</div>
	);
};

Header.propTypes = {
	screen: PropTypes.string.isRequired,
	changeScreen: PropTypes.func.isRequired,
	title: PropTypes.string,
};

Header.defaultProps = {
	title: null,
};

export default Header;



// WEBPACK FOOTER //
// ./src/apps/login_old/components/Header/index.jsx